import { ReferenceListType } from './pitches.enums';

export enum TrainedStatus {
  Precision = 'Precision',
  Trained = 'Trained',
  Untrained = 'Untrained',
  Debug = 'Debug',
}

export enum PitchListOwner {
  None = '',
  Team = 'teams',
  Machine = 'team-machines',
  User = 'team-users',
}

export type PitchListCategory = PitchListOwner | ReferenceListType;

export enum PLStoreMode {
  Library = 'Library',
  PitchList = 'PitchList',
}

export enum PLSortMode {
  CustomOrder = 'common.custom-order',
  Alphabetical = 'common.alphabetical',
  PitchType = 'common.pitch-type',
  Speed = 'common.speed',
  NetSpin = 'common.net-spin',
  BreaksV = 'common.v-break',
  BreaksH = 'common.h-break',
  Frequency = 'common.frequency',
}
